// extracted by css-extract-rspack-plugin
export default {"emptyState":"LQTLO","empyIcon":"hsNrC"};